
import { Vue, Component, Prop } from 'vue-property-decorator';
import { reasonsForExport } from '@/features/common/raw';
import { PartItem } from '@/features/shipment/types';
import { isEuDestination } from '@/features/shipment/helpers/euProductIdentifiers';
import { getPrice } from '@/features/common/helpers';
import { HistoryItemType } from '@/features/shipment-history/types';

@Component
export default class CustomDeclaration extends Vue {
  @Prop({ required: true }) data!: HistoryItemType['commercialInvoice'];

  @Prop({ default: '' }) destinationCountryCode!: string;

  get reasonForExport(): string {
    if (!this.data) return '';

    const { reasonForExport: reason } = this.data;
    return reasonsForExport.find((r) => r.value === reason)?.text || '';
  }

  get customsParts(): PartItem[] {
    if (!this.data) return [];
    return this.data.customsParts;
  }

  get totalInvoiceValue(): number {
    return this.customsParts.reduce((acc, item) => {
      return acc + this.getTotalValue(item);
    }, 0);
  }

  private hasPids(part: PartItem): boolean {
    return isEuDestination(this.destinationCountryCode)
      && !!(part.merchantProductId || part.manufacturerProductId || part.standardProductId);
  }

  private getPrice = getPrice;

  private getTotalValue = (part: PartItem): number => {
    return +part.quantity * +part.unitValue;
  }
}
